module.exports = __webpack_public_path__ + "static/media/Onboarding_Step_1.fdec5b5c.png";